/**
 * Presentation-only formatting helpers.
 *
 * These never derive economic values — they format server-provided numbers/strings
 * for display (the frontend is untrusted; balances/prices come from the API).
 */

/** Format an integer currency amount (mora/primogems/star-glitter) with thin spaces. */
export function formatUnits(value: number): string {
  return new Intl.NumberFormat("ru-RU").format(value);
}

const rubFormatter = new Intl.NumberFormat("ru-RU", {
  style: "currency",
  currency: "RUB",
  maximumFractionDigits: 0,
});

/**
 * Format a server-provided ruble amount (DRF Decimal string or number) for display.
 * Falls back to the raw input on non-numeric values — never derives economic values.
 */
export function formatRub(value: string | number): string {
  const numeric = typeof value === "string" ? Number(value) : value;
  return Number.isFinite(numeric) ? rubFormatter.format(numeric) : String(value);
}

/** Human-friendly compact count for badges (e.g. referrals): caps at ``99+``. */
export function formatBadgeCount(value: number): string {
  if (value <= 0) {
    return "0";
  }
  return value > 99 ? "99+" : String(value);
}
